export default __webpack_public_path__ + "static/media/intro-bg-with-logo.30707b1c.png";